module.exports = __webpack_public_path__ + "img/icon4.14bf1b52.png";